/* @flow */
import Zopim from 'lib/Zopim';
import { changeStatus } from 'reducers/zopim';

export function listenForStatusChange(dispatch: Function) {
  Zopim.addStatusListener(status => {
    if (status === 'online') {
      dispatch(changeStatus('online'));
    } else {
      dispatch(changeStatus('offline'));
    }
  });
}



// WEBPACK FOOTER //
// ./src/lib/zopimListener.js